function Stp (){
 return(
    <div className="fans-list-container" id="game-about">
        {/* HEADER */}
        <div className="header-image"></div>
        <div className="quote">
            <p>If you don't, it will be the end of the world.</p>
        </div>
        <div className="stp-info">
            <p><a href="https://www.slaytheprincess.com/buy">Get the game</a> on Nintendo Switch, PC, PS5, PS4, or Xbox!</p>
            <p>Slay the Princess is a 2023 horror visual novel from <a href="https://blacktabbygames.com/">Black Tabby Games</a>. The game features an ordinary human princess, who you can and should slay. It's very important that you do this.</p>
            <p>Every sprite and background in the game is <a href="https://x.com/blacktabbygames/status/1807831955603411349?lang=en">hand drawn</a> with pencil and paper by  <a href="https://bsky.app/profile/did:plc:pt52o5rslfywmx2spuktecaw">Abby Howard</a>. In its inital 2023 release, it featured ~3000 illustrations. Its free expansion in 2024, the Pristine Cut, added another 1,300.</p>
            <p>The game is fully voice acted by <a href="https://www.twitch.tv/nicholegoodnight">Nicole Goodnight</a> and <a href="https://jonathan-sims.com/">Jonathan Sims</a>.</p>
            <p>For more information and updates on the game, check out the <a href="https://store.steampowered.com/app/1989270/Slay_the_Princess__The_Pristine_Cut/">Steam</a> page!</p>

        </div>
        </div>)
}
export default Stp;